import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { FormikProps } from 'formik';

interface Props {
  formik: FormikProps<any>;
  title?: string;
}

const TradingDurationSection: React.FC<Props> = ({ formik, title = "Trading Duration" }) => (
  <>
    <Grid item xs={12}>
      <Typography variant="subtitle1" gutterBottom>{title}</Typography>
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        type="number"
        id="yearsTrading"
        name="yearsTrading"
        label="Years Trading"
        value={formik.values.yearsTrading || ''}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.yearsTrading && Boolean(formik.errors.yearsTrading)}
        helperText={formik.touched.yearsTrading && formik.errors.yearsTrading as string}
        inputProps={{ min: 0 }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            '& fieldset': {
              borderColor: 'rgba(255, 255, 255, 0.2)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(255, 255, 255, 0.3)',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'primary.main',
            },
          },
          '& .MuiInputLabel-root': {
            color: 'rgba(255, 255, 255, 0.7)',
          },
          '& .MuiInputBase-input': {
            color: 'white',
          },
          '& .MuiFormHelperText-root': {
            color: 'rgba(255, 255, 255, 0.7)',
          },
        }}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        type="number"
        id="monthsTrading"
        name="monthsTrading"
        label="Months Trading"
        value={formik.values.monthsTrading || ''}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.monthsTrading && Boolean(formik.errors.monthsTrading)}
        helperText={formik.touched.monthsTrading && formik.errors.monthsTrading as string}
        inputProps={{ min: 0, max: 11 }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            '& fieldset': {
              borderColor: 'rgba(255, 255, 255, 0.2)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(255, 255, 255, 0.3)',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'primary.main',
            },
          },
          '& .MuiInputLabel-root': {
            color: 'rgba(255, 255, 255, 0.7)',
          },
          '& .MuiInputBase-input': {
            color: 'white',
          },
          '& .MuiFormHelperText-root': {
            color: 'rgba(255, 255, 255, 0.7)',
          },
        }}
      />
    </Grid>
  </>
);

export default TradingDurationSection;
